<prism-header></prism-header>
<div class="center" [ngClass]="{'full-width': (screen.disableMaxWidth$ | async)}">
    <router-outlet></router-outlet>
</div>

<prism-snackbar *ngIf="(snackbarService.renderOnDom$ | async)" class="fade-in"></prism-snackbar>
<prism-dialog *ngIf="(dialog.displayed$ | async)"></prism-dialog>
<prism-bottom-sheet *ngIf="(bottomSheet.displayed$ | async)"></prism-bottom-sheet>

<div *ngIf="appBackgroundOverlayService.overlayDisplayed$ | async" class="background-overlay active">
</div>

<prism-confirmation-dialog *ngIf="(confirmationDialog.dialogDisplayed$ | async)">
</prism-confirmation-dialog>


<div *ngIf="showRefreshSnackbar" class="snackbar show slow-flash">
    <div class="content">
        <div class="center-text">
            <div class="text">new update available</div>
            <div *ngIf="this.showRefreshCountdown">window will refresh in {{timeRemainingString}}</div>
        </div>

        <div class="refresh">
            <div (click)="refresh()" class="button">refresh</div>
        </div>
    </div>
</div>

<div class="appwrite-watermark">
    <span *ngIf="deploymentTargetPrefix">{{ deploymentTargetPrefix }}</span>
    <span>{{ deploymentEnvironmentPrefix }}-{{ deploymentSuffix }}</span>
</div>

<div *ngIf="!!screen.customRightClickMenuOptions$.value.length && rightClickMenuVisible" id="contextMenu"
    class="context-menu" [style.top.px]="rightClickMenuTop" [style.left.px]="rightClickMenuLeft">
    <div class="list-item" *ngFor="let option of screen.customRightClickMenuOptions$.value"
        (click)="option.optionClickFunction()">
        {{option.label}}
    </div>
</div>


<div *ngIf="screen.displayFullPageLoadingSpinner$.value" class="full-page-loading-spinner">
    <div class="loading-spinner-container">
        <prism-loading-spinner></prism-loading-spinner>
    </div>
    <div *ngIf="(screen.fullPageLoadingSpinnerMessage$ | async) as message" class="message slow-flash-still-visible">
        {{ message }}
    </div>
</div>
